import { NgModule } from '@angular/core';

import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import { FuseFullscreenComponent } from '@fuse/components/fullscreen';
import { LanguagesModule } from 'app/layout/common/languages/languages.module';
import { SearchModule } from 'app/layout/common/search/search.module';

import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';

import { SharedModule } from 'app/shared/shared.module';
import { ClassyLayoutComponent } from 'app/layout/layouts/vertical/classy/classy.component';
import { ActiveTagsModule } from '@app/modules/active-tag/active-tags.module';
import { TranslateModule } from '@ngx-translate/core';
import { UserProfileModule } from '@app/modules/login/profile/user-profile.module';
import { NavizardVersioningModule } from "../../../../shared/components/navizard-versioning/navizard-versioning.module";
import { FrostOverlayMenuModule } from 'app/shared/components/frost-overlay-menu';
import { FrostMenuManagerModule } from 'app/shared/services/frost-menu-manager.module';

@NgModule({
    declarations: [
        ClassyLayoutComponent
    ],
    exports: [
        ClassyLayoutComponent
    ],
    imports: [
        RouterModule,
        MatButtonModule,
        MatDividerModule,
        MatIconModule,
        MatMenuModule,
        FuseLoadingBarComponent,
        FuseFullscreenComponent,
        FuseHorizontalNavigationComponent,
        FuseVerticalNavigationComponent,
        LanguagesModule,
        ActiveTagsModule,
        SearchModule,

        SharedModule,
        UserProfileModule,
        TranslateModule.forChild(),
        NavizardVersioningModule,
        FrostOverlayMenuModule,
        FrostMenuManagerModule
    ]
})
export class ClassyLayoutModule {
}
